import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Share2, Check, Copy, Users } from "lucide-react";
import api from "../lib/api";

export const ShareJourney = ({ org, config }) => {
  const [copied, setCopied] = useState(false);
  const [followers, setFollowers] = useState(null);
  useEffect(() => {
    api.get("/followers/count").then(({ data }) => setFollowers(data.count)).catch(() => {});
  }, []);
  const joinCode = org?.join_code;
  if (!joinCode) return null;

  const trip = config?.trip_name || org?.org_name;
  const url = `${window.location.origin}/auth?mode=join&code=${encodeURIComponent(joinCode)}`;
  const message =
    `Follow ${org?.org_name}'s mission journey${trip ? ` — "${trip}"` : ""} on MissionCompanion 🌍\n` +
    `Get dispatches, prayer updates and more. Join us here:\n${url}\n(Join code: ${joinCode})`;

  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: `Join ${org?.org_name}`, text: message, url }); return; }
      catch { /* user cancelled or unsupported — fall through to copy */ }
    }
    try {
      await navigator.clipboard.writeText(message);
      setCopied(true);
      toast.success("Invite copied — paste it anywhere!");
      setTimeout(() => setCopied(false), 2500);
    } catch {
      toast.error("Couldn't copy — long-press to select the link.");
    }
  };

  return (
    <button
      data-testid="home-share-journey"
      onClick={share}
      className="w-full flex items-center gap-3 rounded-2xl p-5 border-2 border-dashed border-[#C9973A]/40 bg-[#C9973A]/5 text-left transition-transform hover:scale-[1.01]"
    >
      <div className="h-11 w-11 rounded-xl bg-[#C9973A]/15 flex items-center justify-center shrink-0 text-[#C9973A]">
        {copied ? <Check className="h-5 w-5" /> : <Share2 className="h-5 w-5" />}
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-heading font-bold text-lg leading-tight text-[#2C2C3E]">Share the journey</div>
        <div className="text-sm text-muted-foreground">Invite friends & supporters to follow along</div>
        {followers > 0 && (
          <div data-testid="followers-count" className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-[#C9973A]/15 text-[#9a6f1f] font-semibold text-xs px-2.5 py-1">
            <Users className="h-3.5 w-3.5" />
            {followers} {followers === 1 ? "partner has" : "partners have"} joined the journey
          </div>
        )}
      </div>
      <Copy className="h-4 w-4 text-muted-foreground shrink-0" />
    </button>
  );
};

export default ShareJourney;
